import { gatewayInstance } from "../axiosInstance";
import { authServerUrl, SERVICE_ENDPOINT } from "../const";

export const employeeDropdown = async (cat) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/employee/bycategory`,
      {
        params: {
          cat,
        },
      },
    );
    console.log(response.data);
    return response.data.map((item) => ({
      key: item.empId,
      text: `${item.empCode} - ${item.empFullName}`,
      value: item.empId,
    }));
  } catch (e) {
    console.error(e);
  }
};

export const addEmployee = async (data) => {
  console.log(`data`);
  console.log(data);
  const response = await gatewayInstance.post(
    `${SERVICE_ENDPOINT.TRANSPORT}/employeecreation`,
    data,
  );
  console.log(response);
  return response;
};

export const searchEmployee = async (data) => {
  try {
    console.log(data);
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/employee/search`,
      data,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};
export const employeeById = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/employeecreation/${id}`,
    );
    console.log(response.data);
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const employeeByMultipleId = async (ids) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/employeecreation/employees`,
      ids,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getContactDetails = async (ope, ref) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/contactdetails/byopeandref/${ope}/${ref}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const updateEmployee = async (data) => {
  return await gatewayInstance.put(
    `${SERVICE_ENDPOINT.TRANSPORT}/employeecreation`,
    data,
  );
};

export const validateFieldUserName = async (field, value) => {
  try {
    const response = await gatewayInstance.get(
      `${authServerUrl}/console/user/validate`,
      {
        params: {
          field,
          value,
        },
      },
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const validateAccountCreation = async (userName, email, opeType) => {
  const emailExists = await validateFieldUserName("email", email, opeType);
  if (emailExists) {
    return "DUPLICATE";
  }

  const userNameExists = await validateFieldUserName(
    "username",
    userName,
    opeType,
  );
  if (userNameExists) {
    return "EMAIL_MISMATCH";
  }

  return "AVAILABLE";
};

export const bulkUpdateStatusChange = async (data) => {
  try {
    const response = await gatewayInstance.put(
      `${SERVICE_ENDPOINT.TRANSPORT}/employee/bulk-status`,
      data,
    );

    return response.data;
  } catch (error) {
    console.error("Bulk update error:", error);
    throw error;
  }
};
